import React, { useEffect } from 'react'
import isMobile from 'ismobilejs'
import { constants, htmlTranslation } from '@pmi/pmi-iqos-shared-react'
import { Container, TextBody } from '@pmi/pmi-iqos-ds-react'
import { Global, css } from '@emotion/react'

const adyenDropinId = 'threeds-container'
const cssOverride = css`
  .adyen-checkout__threeds2__challenge {
    background-color: white !important;
  }
`

const CheckoutCreditCardThreeDS = ({
  translations,
  threeDS,
  orderId,
  line
}) => {
  useEffect(() => {
    if (threeDS) {
      !window.AdyenWeb ? setupAdyenCheckout() : initAdyenCheckout()
    }
  }, [])

  const setupAdyenCheckout = () => {
    const script = document.createElement('script')
    script.src = constants.ADYEN_SCRIPT_URL
    script.onload = initAdyenCheckout
    document.body.appendChild(script)
    const style = document.createElement('link')
    style.href = constants.ADYEN_STYLES_URL
    style.rel = 'stylesheet'
    document.body.appendChild(style)
  }

  const initAdyenCheckout = async () => {
    const configuration = {
      clientKey: line
        ? constants.ADYEN_ORIGIN_KEY_LINE
        : constants.ADYEN_ORIGIN_KEY_ZYN,
      locale: 'ja-JP',
      countryCode: 'JP',
      environment: constants.ADN_ENVIRONMENT,
      onAdditionalDetails: state => {
        threeDS?.callback(state?.data, threeDS?.orderId)
      },
      onError: () => {
        threeDS?.callback()
      }
    }
    const { AdyenCheckout } = window.AdyenWeb
    const checkout = await AdyenCheckout(configuration)
    checkout
      .createFromAction(threeDS?.action, {
        challengeWindowSize: isMobile().any ? '05' : '02'
      })
      .mount('#' + adyenDropinId)
  }

  return (
    <Container>
      <Global styles={cssOverride} />
      <Container px={['8', '0']}>
        <div id={adyenDropinId} />
      </Container>
      <Container py="8" px={['4', '0']}>
        <TextBody
          style={TextBody.styles.grayedout}
          size={TextBody.sizes.s}
          data-testing="Checkout_TextBody_PaymentType"
          {...htmlTranslation(
            translations,
            'tk_stepThreeCreditCardLawReminder'
          )}
        />
      </Container>
    </Container>
  )
}

export default CheckoutCreditCardThreeDS
